export class EstadioFenologico {
    Id: number;
    Descricao:string = "";
    DescricaoCompleta:string = "";
    EmpresaId: number;
    CulturaId: number;
}
